/**
 * HOME CONTENT
 * --------------------------------------------------
 * Text is authored as tokenized lines.
 * Any word / phrase can be highlighted dynamically.
 */

export const HOME_CONTENT = [
  {
    id: '1',
    from: 0,
    to: 50,
    lines: [
      [
        { text: 'Leading the Future of ' },
        { text: 'Immersive', highlight: true },
      ],
      [{ text: 'Spatial Intelligence', highlight: true }],
    ],
    desc: [
      [
        {
          text: 'The enterprise suite for immersive technologies, powered by ',
        },
        { text: 'Spatial AI', highlight: true },
        { text: ' — designed to perform across industries.' },
      ],
    ],
    position:
      'left-1/2 top-[30%] md:top-[40%] -translate-x-1/2 -translate-y-1/2',
    customStyle: 'items-center justify-center text-center px-4',
    headingStyle: 'max-w-3xl text-2xl md:text-5xl md:space-y-2 ',
    descStyle: 'text-[#BBBBBB] text-lg max-w-lg',
  },

  {
    id: '2',
    from: 65,
    to: 110,
    lines: [
      [
        { text: 'Spatial Grid is built on ' },
        { text: 'Immersive Spatial Models (ISMs) —', highlight: true },
        { text: ' advanced', highlight: false },
      ],
      [
        {
          text: ' multimodal AI systems that replicate real-world spaces and human behavior.',
        },
        { text: ' Powering ' },
        { text: 'Simulations', highlight: true },
        { text: ', ' },
        { text: 'Extended Reality', highlight: true },
        { text: ', and ' },
        { text: 'GIS Systems', highlight: true },
        { text: '.' },
      ],
    ],
    position: 'left-1/2 top-[40%] -translate-x-1/2 -translate-y-1/2',
    customStyle: 'items-center justify-center text-center',
    headingStyle: 'max-w-4xl text-lg md:text-2xl',
  },

  {
    id: '3',
    from: 290,
    to: 330,
    lines: [
      [
        { text: 'Train Safer. Operate Smarter.' },
        { text: ' Scale Faster.', highlight: true },
      ],
    ],
    desc: [
      [
        { text: 'Spatial Grid delivers an intelligent ' },
        { text: 'XR Training Platforms', highlight: true },
        { text: ' for complex, high-risk industries.' },
      ],
    ],
    position: 'left-1/2 top-[40%] -translate-x-1/2 -translate-y-1/2',
    customStyle: 'items-center justify-center text-center px-4',
    headingStyle: 'max-w-2xl text-2xl md:text-5xl shadow-xl',
    descStyle: 'text-white md:max-w-md shadow-xl',
  },

  {
    id: '4',
    from: 350,
    to: 500,
    lines: [
      [
        { text: 'From ' },
        { text: 'Site Tours', highlight: true },
        { text: ' to' },
      ],
    ],
    position: 'left-1/2 -translate-x-1/2 top-[25%]',
    customStyle: 'items-center justify-start',
    headingStyle: 'max-w-lg text-2xl md:text-5xl text-center',
  },

  {
    id: '5',
    from: 440,
    to: 500,
    lines: [[{ text: 'Store Fronts.', highlight: true }]],
    position: 'left-1/2 -translate-x-1/2 top-[29%] md:top-[33%]',
    customStyle: 'items-center justify-start',
    headingStyle: 'max-w-lg text-2xl md:text-5xl text-center',
  },

  {
    id: '6',
    from: 550,
    to: 860,
    lines: [
      [
        { text: 'From ' },
        { text: 'Showrooms', highlight: true },
        { text: ' to' },
      ],
    ],
    position: 'md:left-[5%] top-[15%] md:top-[25%]',
    customStyle: 'items-center md:items-start justify-start',
    headingStyle: 'max-w-lg text-2xl md:text-5xl text-center',
  },

  {
    id: '7',
    from: 740,
    to: 860,
    lines: [[{ text: 'Shelf Space.', highlight: true }]],
    position: 'md:left-[5%] top-[18%] md:top-[33%]',
    customStyle: 'items-center md:items-start justify-start',
    headingStyle: 'max-w-lg text-2xl md:text-5xl',
  },

  {
    id: '8',
    from: 790,
    to: 860,
    desc: [
      [
        { text: 'Immersive brand journeys now begin in ' },
        { text: 'XR', highlight: true },
        { text: '. With ' },
        { text: 'AI-personalized walkthroughs', highlight: true },
        { text: ', product interactions, and layered storytelling, ' },
        { text: 'Spatial Grid', highlight: true },
        { text: ' redefines engagement.' },
      ],
    ],
    position: 'md:right-[5%] bottom-[10%]',
    descStyle: 'text-white max-w-lg text-lg font-bold',
    customStyle: 'items-end justify-center text-left',
  },

  {
    id: '9',
    from: 1100,
    to: 1160,
    lines: [
      [
        { text: 'Turning Lessons into ' },
        { text: 'Spatial Journeys. ', highlight: true },
        { text: 'Beyond the page into the world.' },
        { text: 'See it, feel it, understand it.' },
      ],
    ],
    position: 'left-1/2 top-[40%] -translate-x-1/2 -translate-y-1/2',
    customStyle: 'justify-center text-center items-center px-4',
    headingStyle: 'max-w-2xl text-2xl md:text-3xl',
  },

  {
    id: '10',
    from: 1300,
    to: 1400,
    lines: [
      [
        { text: 'Digital Twins, Simulating Ops, from ' },
        { text: 'Cockpits', highlight: false },
        { text: ' to ' },
        { text: 'Command Centers', highlight: false },
        { text: ' Immersive superiority for ' },
        { text: 'Air, Land, Water, and, Space', highlight: true },
      ],
    ],
    position: 'left-1/2 -translate-x-1/2 bottom-[40%]',
    customStyle: 'justify-center text-center items-center',
    headingStyle: 'max-w-3xl text-xl md:text-3xl',
  },
];
